// Import necessary styles and libraries
import { createApp } from 'vue';
import ImportRecordingDialog from "./ImportRecordingDialog.vue";
import { i18n } from '../../i18n';

// Check if the specific element exists in the DOM
if (document.querySelector('#vue-import-recording-dialog')) {
  // Create a new Vue instance and mount it to the element
  const app = createApp(ImportRecordingDialog);
  app.use(i18n);
  app.mount('#vue-import-recording-dialog');
}
